<template>
  <el-dialog
    title="提示信息"
    :visible.sync="dialogerror"
    top="20%"
    width="420px"
    :lock-scroll=false
    custom-class="dialog"
    @close="ErrorClose">
    <img style="margin-left: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
    <span class="z-font-size-14 z-margin-left-5-precent">{{errorMsg}}</span>
    <span slot="footer" class="dialog-footer">
          </span>
  </el-dialog>
</template>

<script>
    export default {
      props:{
        dialogError: { type: Boolean, default:false },
        errorMsg: { type: String, default:'错误' },
      },
      data() {
        return {
          dialogerror: false,
        }
      },
      watch: {
        dialogError(){
          this.dialogerror = this.dialogError
        }
      },
      methods:{
        ErrorClose() {
          this.$emit('ErrorClose',false)
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/XdialogError.vue